module.exports = __webpack_public_path__ + "static/media/tipologia14.dd035569.png";